import YaCounter from "../analytics/ym";
import {stateCatalogElement} from "./_function";
import GoogleAnalytics from "../analytics/ga";

window.VegasCatalog.Compare = {
	add: function (lparams, callback) {
		lparams = lparams || {};
		lparams._token = App.csrf;

		this.addRequest(lparams, function (data) {
			if (!data.error) {
				VegasCatalog.popup(' Товар добавлен в сравнение');
				VegasCatalog.Compare.totals(data);

				if (typeof callback == 'function')
					callback(data);
			}
		});
	},

	del: function (lparams, callback) {
		lparams = lparams || {};
		lparams._token = App.csrf;

		this.delRequest(lparams, function (data) {
			if (!data.error) {
				VegasCatalog.popup(' Товар убран из сравнения');
				VegasCatalog.Compare.totals(data);

				if (typeof callback == 'function')
					callback(data);
			}
		});
	},

	addRequest: function (params, callback) {
		$.post('/compare/add_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);

			new YaCounter().goal('add-to-compare');
			new GoogleAnalytics().goal('Add-to-compare');
		});
	},

	delRequest: function (params, callback) {
		$.post('/compare/del_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	totals: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-compare][data-counter="products"]').attr('data-cnt', data.products_count);
		}
	},
};

$(document).ready(function () {
	const stateAdditionalCompare = {
		prd: {
			class: 'in-compare'
		},
		btn: {
			classes: {
				add: 'btn-light',
				del: 'btn-dark'
			},
			title: {
				isTitleText: false,
				isTooltipText: true,
				text: {
					add: 'В сравнение',
					del: 'Убрать из сравнения'
				}
			}
		}
	};

	/** ADD **/
	$(document).on('click', '[data-product] [data-compare][data-action=add]', function () {
		let $product = $(this).closest('[data-product]');
		let $btn = $(this);

		VegasCatalog.Compare.add({
			id: $product.data('id')
		}, function (data) {
			stateCatalogElement($product, $btn, 'add', stateAdditionalCompare)
		});

		return false;
	});
	$(document).on('click', '[data-product-modal] [data-compare][data-action=add]', function () {
		let $product = $(this).closest('[data-product-modal]');
		let $btn = $(this);

		VegasCatalog.Compare.add({
			id: $product.data('id')
		}, function (data) {
			stateCatalogElement($product, $btn, 'add', stateAdditionalCompare)
		});

		return false;
	});

	$(document).on('click', '[data-product-item] [data-compare][data-action=add]', function () {
		let $product = $(this).closest('[data-product-item]'),
			$btn = $(this);

		VegasCatalog.Compare.add({
			id: $product.data('id')
		}, function (data) {
			stateCatalogElement($product, $btn, 'add', stateAdditionalCompare);
		});

		return false;
	});

	$(document).on('click', '[data-product-cart-item] [data-compare][data-action=add]', function () {
		let $product = $(this).closest('[data-product-cart-item]'),
			$btn = $(this);

		VegasCatalog.Compare.add({
			id: $product.data('id')
		}, function (data) {
			stateCatalogElement($product, $btn, 'add', stateAdditionalCompare);
		});

		return false;
	});

	/**  REMOVE **/
	$(document).on('click', '[data-product] [data-compare][data-action=del]', function () {
		let $product = $(this).closest('[data-product]');
		let $btn = $(this);

		VegasCatalog.Compare.del({
			id: $product.data('id')
		}, function (data) {
			stateCatalogElement($product, $btn, 'del', stateAdditionalCompare)
		});

		return false;
	});
	$(document).on('click', '[data-product-modal] [data-compare][data-action=del]', function () {
		let $product = $(this).closest('[data-product-modal]');
		let $btn = $(this);

		VegasCatalog.Compare.del({
			id: $product.data('id')
		}, function (data) {
			stateCatalogElement($product, $btn, 'del', stateAdditionalCompare)
		});

		return false;
	});

	$(document).on('click', '[data-product-item] [data-compare][data-action=del]', function () {
		let $product = $(this).closest('[data-product-item]');
		let $btn = $(this);

		VegasCatalog.Compare.del({
			id: $product.data('id')
		}, function (data) {
			stateCatalogElement($product, $btn, 'del', stateAdditionalCompare);
		});

		return false;
	});

	$(document).on('click', '[data-product-cart-item] [data-compare][data-action=del]', function () {
		let $product = $(this).closest('[data-product-cart-item]');
		let $btn = $(this);

		VegasCatalog.Compare.del({
			id: $product.data('id')
		}, function (data) {
			stateCatalogElement($product, $btn, 'del', stateAdditionalCompare);
		});

		return false;
	});

	$(document).on('click', '[data-product-compare] [data-compare][data-action=del]', function () {
		let $product = $(this).closest('[data-product-compare]'),
			$slide = $product.closest('.swiper-slide'),
			index = $slide.data('index'),
			$carousel = $slide.closest('.swiper-wrapper');

		let $compare = document.getElementById('slider-compare'),
			$swiper = $compare.swiper;

		VegasCatalog.Compare.del({
			id: $product.data('id')
		}, function (data) {

			if (!data.products_count) {
				Turbo.visit(location.href);
			} else {
				$swiper.removeSlide(index);

				document.querySelectorAll('.' + $compare.dataset.dependence).forEach(function (currentValue) {
					let $carousel = document.getElementById(currentValue.attributes.id.nodeValue).swiper;
					$carousel.removeSlide(index)
				});

				setTimeout(() => {
					// new index
					$carousel.find('.swiper-slide').each(function (i) {
						$(this).data('index', i);
					});
				}, 100)
			}
		});

		return false;
	});
});
